import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { Link } from "react-router-dom";

import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";

import portfoliosArray from "../../DataJs/portfolio.js";

const Team = () => {
  const [portfolios, setPortfolios] = useState([]);

  useEffect(() => {
    setPortfolios(portfoliosArray);
  }, []);

  return (
    <section
      className="bg-smoke space"
      style={{
        backgroundImage: "url(/assets/img/bg/team_bg_2.png)",
      }}
    >
      <div className="container">
        {/* Header */}
        <div className="title-area text-center">
          <span className="sub-title d-flex justify-content-center align-items-center">
            <div className="icon-masking me-2">
              <span
                className="mask-icon"
                style={{
                  WebkitMaskImage:
                    "url(/assets/img/theme-img/title_shape_2.svg)",
                  maskImage: "url(/assets/img/theme-img/title_shape_2.svg)",
                }}
              ></span>
              <img src="assets/img/theme-img/title_shape_2.svg" alt="shape" />
            </div>
            Portfolio
          </span>
          <h2 className="sec-title">
            Explore Our Creative
            <span className="text-theme fw-normal">Portfolio</span>
          </h2>
        </div>

        {/* Slider */}
        <div className="slider-area position-relative">
          <Swiper
            modules={[Autoplay, Navigation]}
            loop={true}
            spaceBetween={24}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            navigation={{
              prevEl: ".team-prev",
              nextEl: ".team-next",
            }}
            breakpoints={{
              0: { slidesPerView: 1 },
              576: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              992: { slidesPerView: 2 },
              1200: { slidesPerView: 3 },
            }}
          >
            {portfolios.map((project) => (
              <SwiperSlide key={project.id}>
                <div className="project-card">
                  <div className="project-img">
                    <img src={project.img} alt={project.title} />
                  </div>

                  <div className="project-content-wrap">
                    <div className="project-content">
                      <div
                        className="box-particle"
                        id={`project-p${project.id}`}
                      ></div>

                      <h3 className="box-title">
                        <Link to={`/portfolio/portfolio-details/${project.id}`}>
                          {project.title}
                        </Link>
                      </h3>

                      <p className="project-subtitle">{project.category}</p>

                      <Link
                        to={`/portfolio/portfolio-details/${project.id}`}
                        className="icon-btn"
                      >
                        <i className="far fa-plus"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Custom Arrows (Same Design) */}
          <button className="slider-arrow style3 slider-prev team-prev">
            <i className="far fa-arrow-left"></i>
          </button>

          <button className="slider-arrow style3 slider-next team-next">
            <i className="far fa-arrow-right"></i>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Team;
